"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _wangeditor = _interopRequireDefault(require("wangeditor"));
//
//
//
var _default2 = exports.default = {
  props: {
    editorId: {
      default: function _default() {
        return null;
      }
    },
    editorContent: {
      default: function _default() {
        return null;
      }
    }
  },
  data: function data() {
    return {
      content: "",
      uploadImgUrl: process.env.VUE_APP_BASE_API + "/common/upload"
    };
  },
  mounted: function mounted() {
    if (!this.$route.query.id) {
      this.initEditor();
    }
  },
  methods: {
    initEditor: function initEditor() {
      var _this = this;
      var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      // 编辑器初始化
      var self = this;
      var editor = new _wangeditor.default(document.getElementById(this.editorId));
      this.content = text;
      editor.config.onchange = function (html) {
        _this.content = html;
        _this.$emit("update:editorContent", _this.content);
      };
      editor.config.zIndex = 100;
      editor.config.uploadFileName = "file";
      editor.config.uploadImgServer = this.uploadImgUrl; // 上传图片
      editor.config.customUploadImg = function (files, insert) {
        var formData = new FormData();
        formData.append("file", files[0]);
        var xhr = new XMLHttpRequest();
        xhr.open("POST", self.uploadImgUrl, true);
        xhr.onload = function () {
          if (xhr.status === 200) {
            var res = JSON.parse(xhr.responseText);
            if (res.code == 1) {
              insert(res.ossOriUrl);
            }
          }
        };
        xhr.send(formData);
      };
      editor.config.menus = ["head", "bold", "fontSize", "fontName", "italic", "underline", "strikeThrough", "indent", "lineHeight", "foreColor", "backColor", "link", "list", "justify", "quote", "image", "video", "table", "code", "undo", "redo"];
      editor.create();
      editor.txt.html(this.content);
      self.weditor = editor;
    }
  }
};